import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';

interface BoundaryProps { children: ReactNode }
interface BoundaryState { failed: boolean }

export class AppErrorBoundary extends Component<BoundaryProps, BoundaryState> {
  state: BoundaryState = { failed: false };

  static getDerivedStateFromError(): BoundaryState { return { failed: true }; }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('ChanHub page failed to render', error, info.componentStack);
  }

  render() {
    if (this.state.failed) return <main className="grid min-h-[45vh] place-items-center bg-[#080b11] px-5 text-center text-slate-300">
      <section><h1 className="text-lg font-semibold">页面暂时无法显示</h1><p className="mt-2 text-sm text-slate-500">刷新页面后可以继续使用。</p><button type="button" onClick={() => location.reload()} className="mt-5 rounded-lg bg-blue-600 px-4 py-2 text-sm text-white hover:bg-blue-500">刷新页面</button></section>
    </main>;
    return this.props.children;
  }
}
